<template>
  <v-btn @click.prevent="click" small icon>
    <v-icon>{{ icon }}</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: 'SmallIconButton',
  props: {
    icon: {
      type: String,
      required: true
    }
  },
  methods: {
    click () {
      this.$emit('click')
    }
  }
}
</script>
